<template>
  <section class="not-found">
    <h1>404</h1>
    <p>Page not found</p>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import './scss/variables';

.not-found {
  padding: $gs * 2;
}
</style>

<script>
// @flow
export default {
  name: 'not-found'
}
</script>
